/* Carga perezosa + control del panel de método de envío (Shalom/Olva/Domicilio)
   dentro del carrito desplegable.
   Este archivo es pequeño y SIEMPRE se carga; el widget pesado (con la
   base de datos de agencias) solo se descarga la primera vez que el
   cliente abre el panel, para no afectar el peso de las demás páginas.
   El bloqueo del botón de pago se calcula leyendo los atributos
   data-aev-required / data-aev-locked de #CartDrawer-Agency-Sheet, que se
   renderizan server-side desde cart.attributes y viven FUERA de la región
   que Shopify reemplaza en cada refresco AJAX del carrito — por eso el
   bloqueo funciona incluso si el cliente nunca llega a abrir el panel. */
(function () {
  var loading = false;
  var callbacks = [];

  function loadWidgetAssets(cb) {
    if (window.CartDrawerAgencyWidget) {
      cb();
      return;
    }
    callbacks.push(cb);
    if (loading) return;
    loading = true;

    var assets = window.CartDrawerAgencyAssets || {};

    if (assets.css) {
      var link = document.createElement('link');
      link.rel = 'stylesheet';
      link.href = assets.css;
      document.head.appendChild(link);
    }

    if (!assets.js) return;
    var script = document.createElement('script');
    script.src = assets.js;
    script.onload = function () {
      var toRun = callbacks;
      callbacks = [];
      toRun.forEach(function (fn) {
        try { fn(); } catch (e) {}
      });
    };
    document.body.appendChild(script);
  }

  function sheetEl() {
    return document.getElementById('CartDrawer-Agency-Sheet');
  }

  function openSheet() {
    var sheet = sheetEl();
    if (!sheet) return;
    sheet.classList.add('is-open');
    sheet.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('cd-agency-sheet-open');
    loadWidgetAssets(function () {
      if (window.CartDrawerAgencyWidget) window.CartDrawerAgencyWidget.onOpen();
    });
  }

  function closeSheet() {
    var sheet = sheetEl();
    if (!sheet) return;
    sheet.classList.remove('is-open');
    sheet.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('cd-agency-sheet-open');
  }

  function showWarning() {
    var sheet = sheetEl();
    if (!sheet) return;
    openSheet();
    var warning = sheet.querySelector('[data-aev-warning]');
    if (warning) {
      warning.classList.remove('show');
      void warning.offsetWidth;
      warning.classList.add('show');
    }
  }

  /* ---- Bloqueo del botón de pago (funciona sin cargar el widget pesado) ---- */
  var CHECKOUT_SELECTOR = '[name="checkout"], .cart__checkout-button, #CartDrawer-Checkout, #checkout, a[href="/checkout"], a[href^="/checkout"], #CartDrawer #rsi_buy_now_button';

  function isLocked() {
    var sheet = sheetEl();
    if (!sheet) return false;
    return sheet.getAttribute('data-aev-required') === 'true' && sheet.getAttribute('data-aev-locked') === 'true';
  }

  function applyVisualLock() {
    var locked = isLocked();
    document.querySelectorAll(CHECKOUT_SELECTOR).forEach(function (btn) {
      if (locked) {
        btn.setAttribute('aria-disabled', 'true');
        btn.style.opacity = '.5';
        btn.style.cursor = 'not-allowed';
      } else {
        btn.removeAttribute('aria-disabled');
        btn.style.opacity = '';
        btn.style.cursor = '';
      }
    });
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest(CHECKOUT_SELECTOR);
    if (!btn) return;
    if (isLocked()) {
      e.preventDefault();
      e.stopPropagation();
      showWarning();
    }
  }, true);

  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('[data-cd-agency-open]')) {
      openSheet();
      return;
    }
    if (e.target.closest && e.target.closest('[data-cd-agency-close]')) {
      closeSheet();
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' || e.key === 'Esc') {
      var sheet = sheetEl();
      if (sheet && sheet.classList.contains('is-open')) closeSheet();
    }
  });

  /* Re-aplicar el bloqueo solo cuando el carrito desplegable realmente
     cambia (p.ej. Shopify reemplaza el footer/botón de pago en un refresco
     AJAX) — no en todo el <body>. Antes observábamos document.body entero
     con subtree:true más un setInterval corriendo para siempre en TODAS
     las páginas del sitio (incluida la home), lo cual generaba una carga
     de trabajo innecesaria (carruseles, apps de chat, popups, etc. también
     disparaban el observer) y podía contribuir a que el navegador matara
     la pestaña por uso de memoria/CPU en sesiones largas. Acotar el
     observer a #CartDrawer (que ya existe en el DOM al cargar la página)
     cubre el mismo caso real sin ese costo, y ya no hace falta el polling
     por intervalo porque el widget también llama a applyVisualLock()
     explícitamente cada vez que cambia el estado de bloqueo. */
  applyVisualLock();
  var cartDrawerEl = document.getElementById('CartDrawer');
  if (cartDrawerEl) {
    var lockDebounce;
    var mo = new MutationObserver(function () {
      clearTimeout(lockDebounce);
      lockDebounce = setTimeout(applyVisualLock, 50);
    });
    mo.observe(cartDrawerEl, { childList: true, subtree: true });
  }

  window.CartDrawerAgencyBootstrap = {
    openSheet: openSheet,
    closeSheet: closeSheet,
    applyVisualLock: applyVisualLock,
    isLocked: isLocked
  };
})();
